export function extractErrorMessage (e: unknown): string {
  if (e instanceof Error) {
    return e.message;
  }
  if (
    typeof e === 'object' &&
    e !== null &&
    'message' in e &&
    typeof (e as Record<string, unknown>).message === 'string'
  ) {
    return (e as { message: string }).message;
  }
  return String(e);
}
